import { Outlet } from "react-router-dom";
import BaseCom from "../../../components/BaseCom"
import { withParamsAndNavigate } from "../../../components/WithParamsAndNavigate"
import Auth from "../../../shared/Auth";

class Internal extends BaseCom {
    async componentDidMount() {
        try {
            let user = await Auth.getLoginAsync();
            if(!user.isInternal) {
                this.redirect('/login');
            }
        }
        catch(e) {
            this.unkownErrorCallback(e);
        }
    }

    render() {
        return <Outlet />;
    }
}

export default withParamsAndNavigate(Internal);